import type { ChainRunStatus } from '@/types';

export const chainRunStatusFilterOptions: { value: ChainRunStatus | ''; label: string }[] = [
  { value: '', label: 'All Statuses' },
  { value: 'Running', label: 'Running' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Failed', label: 'Failed' },
  { value: 'AwaitingInputs', label: 'Awaiting Inputs' },
  { value: 'AwaitingManualStart', label: 'Awaiting Manual Start' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Pending', label: 'Pending' },
]

export const chainRunProgressColorClasses: Record<ChainRunStatus, string> = {
  Completed: 'bg-success-foreground',
  Running: 'bg-info-foreground',
  AwaitingInputs: 'bg-warning-foreground',
  AwaitingManualStart: 'bg-warning-foreground',
  Pending: 'bg-neutral-foreground',
  Failed: 'bg-danger-foreground',
  Cancelled: 'bg-cancelled-foreground',
}
